import __request__ from 'routing/request';
/**
 * Updates the AWS default configuration.
 */
export function updateConfig(): Promise<unknown> {
    return __request__('PUT', '/config', null, {}, {
        'Accept': ['application/json']
    });
}
